import {
  createRouter as CreateVueRouter,
  createMemoryHistory,
  createWebHistory,
} from 'vue-router';

import { scrollBehavior } from '@ozdao/martyrs/modules/core/client';
import LayoutClient from '@/components/layouts/LayoutClient.vue';

import Logotype from '@/components/icons/Logotype.vue'
import Header from '@/components/partials/Header.vue'
import Footer from '@/components/partials/Footer.vue'

import { Header as MartyrHeader, Sidebar, Navigation } from '@ozdao/martyrs/modules/core/client'

import auth from '@ozdao/martyrs/modules/auth/client';

import { specialsRoutes } from '@/components/specials/router.js';

const isServer = typeof window === 'undefined';

let history = isServer ? createMemoryHistory() : createWebHistory();

const routes = [{
  path: '/:locale?',

  components: {
    default: LayoutClient
  },

  beforeEnter: [
      ...(process.env.MOBILE_APP ? [auth.views.middlewares.validationAuth.initUser] : [])
    ],

  name: 'Home',

  meta: {
    location: false,
    header: MartyrHeader,
    header_show_cart: false,
    header_show_profile: false,
    logotype: Logotype,
    sidebar: Sidebar,
    sidebar_navigation: Navigation,
    sidebar_hover: true,
  },

    children: [{
      name: "Home Page",
      path: '',
      meta: { header: Header, sidebar_width_hidden: 'w-zero', footer: Footer },
      component: () => import(/* webpackChunkName: 'Home' */ '@/components/pages/Home.vue'),
    },
    // Страницы галереи, меню, about и контактов выключены 2026-10-17 по решению
    // владельца: работают только главная и visit-terms. Включить —
    // раскомментировать маршрут и ссылки с той же пометкой (Footer, VisitTerms,
    // UniqueDrinks, CulinaryExcellence, public/sitemap.xml).
    // {
    //   name: 'Gallery',
    //   path: 'gallery',
    //   meta: { header: Header, sidebar_width_hidden: 'w-zero', footer: Footer },
    //   component: () => import(/* webpackChunkName: 'Gallery' */ '@/components/pages/Gallery.vue'),
    // },{
      // Страница меню выключена 2026-10-17 по решению владельца. Включить —
      // раскомментировать маршрут и ссылки с той же пометкой (Footer,
      // UniqueDrinks, CulinaryExcellence, public/sitemap.xml).
    //   name: 'Menu',
    //   path: 'menu',
    //   meta: { header: Header, sidebar_width_hidden: 'w-zero', footer: Footer },
    //   component: () => import(/* webpackChunkName: 'Menu' */ '@/components/pages/Menu.vue'),
    // },{
    //   name: 'About',
    //   path: 'about',
    //   meta: { header: Header, sidebar_width_hidden: 'w-zero', footer: Footer },
    //   component: () => import(/* webpackChunkName: 'About' */ '@/components/pages/About.vue'),
    // },
    // {
    //   name: 'Nightlife',
    //   path: 'nightlife',
    //   meta: { darkTheme: true },
    //   component: () => import(/* webpackChunkName: 'Nightlife' */ '@/components/pages/Nightlife.vue'),
    // },
    {
      name: 'Visit Terms',
      path: 'visit-terms',
      meta: { header: Header, sidebar_width_hidden: 'w-zero', footer: Footer },
      component: () => import(/* webpackChunkName: 'VisitTerms' */ '@/components/pages/VisitTerms.vue'),
    },
    {
      name: 'Privacy',
      path: 'privacy',
      meta: { header: Header, sidebar_width_hidden: 'w-zero', footer: Footer },
      component: () => import(/* webpackChunkName: 'Privacy' */ '@/components/pages/Privacy.vue'),
    },
    // Страница контактов выключена 2026-10-17 (см. пометку выше).
    // {
    //   name: 'Contacts',
    //   path: 'contacts',
    //   meta: { header: Header, header_theme: 'dark', sidebar_width_hidden: 'w-zero', footer: Footer },
    //   component: () => import(/* webpackChunkName: 'Contacts' */ '@/components/pages/Contacts.vue'),
    // },
    ...specialsRoutes
  ]
  }
];

export function getRouter(context) {
  return CreateVueRouter({
    routes,
    history,
    scrollBehavior: scrollBehavior('#screen')
  });
}
